/** Событие окна: чат альянса прочитан (счётчик почты в шапке перечитывается). */
export const ALLIANCE_CHAT_READ = 'sk:alliance-chat-read';
/** Событие окна: новости прочитаны (вкладка «Новости» открыта) — счётчики почты перечитываются. */
export const NEWS_READ = 'sk:news-read';
/** Событие окна: что-то в почте прочитано или принято (переписка, заявка в друзья) — счётчики перечитываются. */
export const MAIL_COUNTS_CHANGED = 'sk:mail-counts-changed';
